import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useCreateAkteMutation } from '../../../graphql/mutations/m2Case/__generated__/createAkteMutation.generated'
import { useCase, useNotification } from '../../../utils/hooks'
import { Button } from '../../atoms'

export interface CreateAkteButtonProps {
  disabled?: boolean
}

const CreateAkteButton = ({ disabled = false }: CreateAkteButtonProps) => {
  const { t } = useTranslation(['common', 'huk'])
  const { m2Case, refetch } = useCase()
  const { setNotification } = useNotification()
  const [createAkteMutation, { loading }] = useCreateAkteMutation()
  const {
    formState: { isDirty }
  } = useFormContext()

  if (!m2Case?.canCreateAkte) {
    return null
  }

  return (
    <Button
      color="primary"
      fullWidth
      loading={loading}
      disabled={disabled || isDirty}
      onClick={() => {
        createAkteMutation({
          variables: { caseId: m2Case.id },
          onCompleted: () => {
            setNotification({
              open: true,
              variant: 'success',
              title: t('common:success'),
              message: t('huk:createAkteSuccess')
            })
            refetch()
          },
          onError: error => {
            setNotification({
              open: true,
              variant: 'error',
              title: t('common:error'),
              message: error?.message
            })
          }
        })
      }}
    >
      {t('huk:createAkte')}
    </Button>
  )
}

export default CreateAkteButton
